import { defineStore } from 'pinia'
import { useApi } from '@provise/composables/api'

export const useActivityStore = defineStore('activity', () => {
  const { model: activityTypes, refresh: fetchActivityTypes } = useApi({
    url: 'catalog/activity_types',
    data: [],
    pick: d => d.data || [],
  })

  const _getOptions = filterCondition =>
    activityTypes.value.filter(filterCondition).map(item => ({
      value: String(item.id),
      label: item.name ? String(item.name) : `ID: ${item.id}`,
    }))

  const getOptions = () => _getOptions(item => !item.parent_id)
  const getOptionsSub = () => _getOptions(item => item.parent_id)

  return {
    activityTypes,
    //
    fetchActivityTypes,
    getOptions,
    getOptionsSub,
  }
})
